import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import useRequireAuth from "../../utils/useRequireAuth";
import { useGetVendorHeaderListQuery } from "../../utils/customer/customerSelect";
import { getPath } from "../../utils/utilityFunctions/stringUtility";

const VendorHeaderHoc = (WrappedComponent) => {
  return function VendorHeader(props) {
    const [activeTab, setActiveTab] = useState(0);
    const navigate = useNavigate();
    const location = useLocation();

    const { token } = useRequireAuth();
    const storedData = localStorage.getItem("company_data");
    const myUserData = localStorage.getItem("myUserData");

    const usetoken = myUserData ? JSON.parse(myUserData) : null;
    const tokens = token ? token : usetoken.token;
    const companyId = storedData ? JSON.parse(storedData) : null;
    const [vendorHeaderList, setVendorHeaderList] = useState([]);

    const { data: vendorHeaderData } = useGetVendorHeaderListQuery({
      tokens,
      companyId,
    });

    useEffect(() => {
      if (vendorHeaderData) {
        setVendorHeaderList(vendorHeaderData);
      }
    }, [vendorHeaderData]);

    useEffect(() => {
      const currentIndex = vendorHeaderList.findIndex((option) => getPath(option) === location.pathname);
      if (currentIndex !== -1) {
        setActiveTab(currentIndex);
      }
    }, [location.pathname]);

    const handleClick = (index, option) => {
      setActiveTab(index);
      navigate(`/vendor${getPath(option.name)}`);
    };

    return (
      <div>
        <div className="mx-4 sm:mx-10 mb-3 sm:mt-5 px-3 sm:pl-5 border border-[#D6D3D3] bg-white items-center rounded">
          <ul className="flex flex-wrap z-10 text-16 sm:text-16 sm:pt-1 sm:gap-4 md:gap-8 ">
            {vendorHeaderList.map((option, index) => (
              <li
                key={option}
                onClick={() => handleClick(index, option)}
                className={`cursor-pointer py-1 ${
                  activeTab === index ? "text-[#203C50] font-500 border-b border-[#203C50]" : "text-[#848687] font-400"
                }`}
              >
                {option.name}
              </li>
            ))}
          </ul>
        </div>

        <WrappedComponent {...props} />
      </div>
    );
  };
};

export default VendorHeaderHoc;
